import { Button, CircularProgress, TextField } from '@mui/material';
import './style.scss';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// import { getOrgChartUser } from '../../services/user.service';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
import { useState } from 'react';
// import { checkAndUpdateUserToken } from '../../utils/auth';

const EmailPage = () => {
    const [loading, setLoading] = useState(false);
    // const navigate = useNavigate();

    const initialValues = {
        email: ''
    };

    const validationSchema = Yup.object({
        email: Yup.string().matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            'Invalid email format'
        ).required('Email is required'),
    });

    const onSubmit = async () => {
        // These lines are commented out to restrict users from accessing the PMS Web UI.
        // setLoading(true);
        // const isUserTokenValid = await checkAndUpdateUserToken();
        // if (!isUserTokenValid) {
        //     sessionStorage.clear();
        //     navigate("/notFound");
        //     return;
        // }
        //
        // const chartId = sessionStorage.getItem("chartId") || "";
        // const userId = sessionStorage.getItem("userId") || '';

        // try {
        //     const userDetails = await getOrgChartUser(chartId, formik.values.email, userId);
        //     if (userDetails && userDetails.statusCode === 200) {
        //         sessionStorage.setItem('user', JSON.stringify(userDetails.data));
        //         navigate('/login');
        //     } else {
        //         toast.error(`Can't access a resource with the provided email`);
        //     }
        // } catch (error) {
        //     toast.error(`Can't access a resource with the provided email`);
        // }
        // setLoading(false);
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    });

    return <div className="emailOuterDiv">
        <form className='email-form' onSubmit={formik.handleSubmit}>
            <span style={{ fontSize: 'x-large', fontWeight: '400' }}>Provide User Email</span>
            <TextField
                className='content-width'
                size='small'
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <Button
                variant="contained"
                className='content-width'
                type='submit'
                // PMS Web UI is deprecated — validation is disabled.
                // disabled={loading}
                disabled
            >Validate
                {
                    loading && <CircularProgress style={{ color: 'white', marginLeft: '5px' }} size='1rem' />
                }
            </Button>
        </form>
    </div>
};

export default EmailPage;